import { getCurrentSessionToken } from "./cognito";

/**
 * Returns the common HTTP headers required by all protected backend endpoints.
 * Retrieves the active Cognito JWT and builds the Authorization header.
 *
 * @throws {Error} If the user is not authenticated or the session has expired.
 *
 * @example
 * const headers = await getAuthHeaders();
 * fetch(url, { headers: { ...headers, "Content-Type": "application/json" } });
 */
export async function getAuthHeaders(): Promise<{ Authorization: string }> {
  const token = await getCurrentSessionToken();

  if (!token) {
    throw new Error("No active session — user must be authenticated.");
  }

  return { Authorization: `Bearer ${token}` };
}
